import React, { Component } from "react";
import {autorun} from 'mobx';
import { inject, observer } from "mobx-react";
import { compose } from "recompose";
import { withRouter, Link } from "react-router-dom";
import { withAuthorization, createUser } from "./utils/auth";
import {db} from './firebase/firebase';

import {
  Form,
  Spin,
  Button,
  Input,
  Tag,
  Icon,
  Divider,
  Avatar,
  Rate,
  List
} from "antd";

import RequestForm from "./RequestForm";

import { Document, Collection } from "firestorter";
import moment from 'moment';
import 'moment/locale/fr';
moment.locale('fr');

const FormItem = Form.Item;
@observer
class RequestDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      request: this.props.location.data ? this.props.location.data.request : null,
      loading: null,
      isReadOnly: true
    };

    this.updateRequest = this.updateRequest.bind(this);
    this.doDelete = this.doDelete.bind(this)
    this.switchEdit = this.switchEdit.bind(this);
    this.dispose = undefined;
    console.log("requestDetails props", this.props);
  }
  requestDocument = new Document("requests/" + this.props.match.params.id);
  request = undefined;

  componentDidMount() {
    if (this.state.request == null) {
      // this.setState({ loading: true });
      this.dispose = autorun(() => {
        this.request = this.requestDocument.data;
        this.setState({ request: this.request });
        console.log("{request}", this.request);
        console.log("{request state}", this.state.request);
      });

      var requests = null;

      // this.setState({ loading: false });
    }
  }
  componentWillUnmount(){
    this.setState({request: null});
    this.dispose();
  }
  async doDelete() {
    this.setState({ loading: true });
    await db.collection('requests').doc(this.props.match.params.id).delete();
    this.setState({ loading: false });
    this.props.history.push("/request");
  }
  async updateRequest(data) {
    try {
      await this.requestDocument.update(data, { merge: true });
      this.setState({isReadOnly: true});
    } catch (e) {
      throw new Error(e);
    }
  }
  switchEdit() {
    if(!this.state.isReadOnly){
      console.log('REQUEST', this.request)
      this.setState(this.props.request ? {request: {...this.props.request}} : {request: this.request});
      console.log('STATe', this.state.request);
    }
    this.setState({ isReadOnly: !this.state.isReadOnly });
  }
  async getUser(userId) {
    if(!this.state.users[userId]){
      var userDocument = new Document("users/" + userId, {
        mode: "off"
      });
      const user = await userDocument.fetch();
      if(user.data) {
        return user.data
      } else {
        return false
      }

    }
  }

  render() {
    // const {user} = this.state;
    console.log("re-render");
    const { startTime, endTime, tasks, nurse, payment, rate, textComment, isCancelled, duration } = this.state.request
      ? this.state.request
      : "";
    return (
      <div>
        <Spin
          spinning={this.state.loading || this.props.userStore.requests.fetching || this.requestDocument.fetching}
          indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "baseline",
              position: "absolute",
              right: 0,
              zIndex: 1000
            }}
          >
            <p style={{ margin: 5 }}>Opérations:</p>
            <Button
              style={{ margin: 5 }}
              type="primary"
              onClick={() => this.switchEdit()}
              loading={
                this.state.loading || this.props.userStore.requests.fetching || this.requestDocument.fetching
              }
            >
              {this.state.isReadOnly ? 'Modifier' : 'Annuler'}
            </Button>

            <Button
              style={{ margin: 5 }}
              type="danger"
              onClick={this.doDelete}
              loading={
                this.state.loading || this.props.userStore.requests.fetching || this.requestDocument.fetching
              }
            >
              Supprimer
            </Button>
          </div>
          <br />
          <Divider orientation="left">
            <div style={{ display: "flex", alignItems: "center", flexDirection: 'Column'}}>
              <h2
                style={{ alignSelf: "center", marginBottom: 0, marginLeft: 15, wordSpacing: '0.2em' }}
              >
                Le {moment(startTime).format("Do MMMM YYYY")} à {moment(startTime).format("HH[h]mm")}
              </h2>
              {rate ? <Rate disabled allowHalf defaultValue={Number(rate)} /> : null}
              {textComment ? <p>{textComment}</p> : <p>Pas de commentaire</p>}
            </div>
          </Divider>
          <br />

            {this.state.request ? (
            <RequestForm
              disabled={this.state.isReadOnly}
              request={this.state.request}
              submit={this.updateRequest}
              switchFunc={this.switchEdit}
            />
          ) : null}
        </Spin>
      </div>
    );
  }
}

const authCondition = authUser => !!authUser;

export default compose(
  withAuthorization(authCondition),
  inject("userStore"),
  withRouter,
  observer
)(RequestDetails);



// WEBPACK FOOTER //
// ./src/RequestDetails.js